<template>
  <v-container>
    <v-layout text-xs-center wrap v-if="has_orders">
      <v-flex mt-2>
        <v-btn :to="`/events/${this.$route.params.event_id}`">Event Home</v-btn>
      </v-flex>
      <v-flex mb-4 xs12>
        <h1>Registration/Order History</h1>
        <h1>신청/주문 내역</h1>
      </v-flex>
      <v-flex mb-4 xs12 class="text-xs-left">
        <h2>Summary</h2>
        <div><b>Number Of Orders:</b> {{ event_orders.length }}</div>
        <div>
          <v-chip>{{ orders_submitted.length }} Awaiting Payment</v-chip>
          <OrdersValue :orders="orders_submitted" />
        </div>
        <div>
          <v-chip>{{ orders_waitlisted.length }} Waitlisted</v-chip>
          <v-chip>{{ orders_paid.length }} Paid</v-chip>
          <v-chip>{{ orders_canceled.length }} Canceled</v-chip>
        </div>
        <v-switch
          v-model="show_canceled"
          label="Show Canceled Orders"
        ></v-switch>
      </v-flex>
      <v-flex mb-4 xs12 text-xs-center>
        <div v-for="order in visible_orders" :key="order.id">
          <Order
            :order="order"
            :paypal_direct="false"
            :order_detail_link="true"
          />
        </div>
      </v-flex>
      <v-flex mt-4 xs12>
        <v-btn :to="`/events/${this.$route.params.event_id}`">OK</v-btn>
      </v-flex>
    </v-layout>
    <v-layout text-xs-center wrap v-else>
      No Orders Yet - Go Shop :)
    </v-layout>
  </v-container>
</template>

<script>
import {mapState} from 'vuex';
import Order from '@/components/Order';
import OrdersValue from '@/components/OrdersValue';

export default {
  components: {Order, OrdersValue},
  data: () => ({event: {}, link_code: '--', show_canceled: false}),
  beforeMount: async function() {
    this.$store.dispatch('loadEventOrders', {
      event_id: this.$route.params.event_id,
    });
    this.$store.dispatch('loadEventSalesChannels', {
      event_id: this.$route.params.event_id,
    });
    this.$store.dispatch('loadEventProducts', {
      event_id: this.$route.params.event_id,
    });
  },
  computed: {
    ...mapState(['event_products', 'event_sales_channels', 'event_orders']),
    has_orders() {
      return this.event_orders.length > 0;
    },
    visible_orders() {
      if (this.show_canceled) {
        return this.event_orders;
      } else {
        return this.event_orders.filter(o => {
          return o.canceled_at == null;
        });
      }
    },
    orders_waitlisted() {
      //return this.event_orders;
      let result = this.event_orders.filter(o => {
        if (o.canceled_at != null) {
          return false;
        }
        console.log('ow1', o.submitted_at);
        return o.submitted_at == null;
      });
      console.log('ow', this.event_orders, result);
      return result;
    },
    orders_submitted() {
      //return this.event_orders;
      let result = this.event_orders.filter(o => {
        if (o.canceled_at != null) {
          return false;
        }
        if (o.paid_at != null) {
          return false;
        }
        console.log('os1', o.paid_at);
        return o.submitted_at != null;
      });
      console.log('op', this.event_orders, result);
      return result;
    },
    orders_paid() {
      //return this.event_orders;
      let result = this.event_orders.filter(o => {
        if (o.canceled_at != null) {
          return false;
        }
        console.log('op1', o.paid_at);
        return o.paid_at != null;
      });
      console.log('op', this.event_orders, result);
      return result;
    },
    orders_canceled() {
      let result = this.event_orders.filter(o => {
        if (o.canceled_at != null) {
          return true;
        }
        return false;
      });
      console.log('oc', this.event_orders, result);
      return result;
    },
  },
  methods: {},
};
</script>

<style></style>
